jQuery(document).ready(function ($) {
    const HEADER = $(".header_menu");
    const T = window.disorder.language;
    const LANG = window.disorder.storeLocale;

    var device = "mobile";
    if ($(window).width() > 768) device = "desk";
    let atc = $("#productAddToCart");
    if (device == "mobile") {
        atc = $("#productAddToCartS");
    }

    let oos = $("button[name='oos']");

    let productTxtWrp = $(".product-hero-wrapper .txt-wrp");
    let txtHeight = productTxtWrp.height() + Number(productTxtWrp.css("padding-top").replace("px", "")) + Number(productTxtWrp.css("padding-bottom").replace("px", ""));
    if ($(window).height() > txtHeight) {
        productTxtWrp.css("top", ($(window).height() - txtHeight) / 2);
    }

    let atcOriginalText = atc.text();
    atc.hover(
        function () {
            atcOriginalText = atc.text();
            if (device == "mobile") return;
            if (!atc.data("variant")) atc.text(T.select_option);
        }, function () {
            if (device == "mobile") return;
            if (!atc.data("variant")) atc.text(atcOriginalText);
        }
    );

    //carousel light header
    var galleryCarousel = new Swiper('.products-gallery-carousel', {
        slidesPerView: "auto",
        loop: false,
        simulateTouch: true,
        freeMode: false,
        pagination: {
            el: ".swiper-pagination",
        }
    });
    galleryCarousel.on('slideChange', function (event) {
        if (!event.activeIndex) {
            HEADER.removeClass("light");
            HEADER.addClass("dark");
            $(".swiper-pagination-bullet").removeClass("light");
            return;
        }
        HEADER.removeClass("dark");
        HEADER.addClass("light");
        $(".swiper-pagination-bullet").addClass("light");
    });

    //product page variant selector
    let activeOptions = [];
    let cp = window.disorder.current.product;
    cp.options.forEach(optionItem => {
        activeOptions.push("");
        $(`.product-hero-wrapper .options[data-group='${optionItem}'] .option`).click(function () {
            let el = $(this);
            let option = el.data("option");
            let position = +el.data("position") - 1;

            $(`.product-hero-wrapper .options[data-group='${optionItem}'] .option.active`).removeClass("active");
            el.addClass("active");

            activeOptions[position] = option;
            setActiveVariant();
        });
    });

    function setActiveVariant(flag = false) {
        atcOriginalText = atc.text();
        let variant;
        let _ = window.disorder.current.product;
        let potential = [..._.variants];
        let upsellTag = findUpsellTag(_.tags);
        activeOptions.forEach((optionItem, i) => {
            potential = potential.filter(x => x.options[i] == optionItem);
        })
        if (!potential[0]) return;
        if (potential.length == 1) variant = potential[0];
        if (flag) {
            return;
        }
        $(".options-title").removeClass("error");
        if (!variant.available) {
            oos.removeClass("d-none");
            $("p.desc").addClass("d-none");
            atc.text(T.when_back);
            atc.attr("data-variant", variant.id);
            atc.attr("data-oos", "true");
            return;
        } else {
            if (!oos.hasClass("d-none")) oos.addClass("d-none");
            if ($("p.desc").hasClass("d-none")) $("p.desc").removeClass("d-none");
            atc.attr("data-oos", "false");
            atc.text(atcOriginalText);
        }
        atc.attr("data-variant", variant.id);
        atc.attr("data-upsell", upsellTag);
        atc.text(T.add_to_cart + " - " + displayMoney(variant.price));
    }

    function findUpsellTag(tags) {
        if (tags.some(tag => tag.includes("upsell"))) {
            return tags.find(tag => tag.includes("upsell"));
        } else {
            return "upsell-general";
        }
    }

    function displayMoney(totalToMoney) {
        if (LANG.code == "he") {
            return "₪" + totalToMoney / 100;
        }
        return "$" + ((totalToMoney / 100) * window.Currency.rates.ILS).toFixed(2);
    }

});

$(window).on("load", function () {

    var device = "mobile";
    if ($(window).width() > 768) device = "desk";
    let atc = $("#productAddToCart");
    if (device == "mobile") {
        atc = $("#productAddToCartS");
    }
    let atcMark = $("#atcMark").position().top - 35;

    //sticky atc
    let currentScrollView = $(window).height() + $(window).scrollTop() - $(".normal-atc").innerHeight();
    if (atcMark > currentScrollView) {
        $(".normal-atc").addClass("sticky-atc");
    }

    $(window).scroll(function () {
        currentScrollView = $(window).height() + $(window).scrollTop() - $(".normal-atc").innerHeight();
        if (atcMark > currentScrollView) {
            if ($(".normal-atc").hasClass("sticky-atc")) return;
            $(".normal-atc").addClass("sticky-atc");
        } else {
            if (!$(".normal-atc").hasClass("sticky-atc")) return;
            $(".normal-atc").removeClass("sticky-atc");
        }
    });

    // *******************DESKTOP**ONLY*************************************
    if ($(window).width() < 769) return;

    const SIDEBAR_EL = $(".product-hero-wrapper .txt-wrp");
    SIDEBAR_EL.css("width", `${SIDEBAR_EL.width()}px`);

    const sidebar = document.querySelector('.product-hero-wrapper .txt-wrp');
    const relative = document.querySelector('.product-hero-wrapper .product-gallery');

    const floatSidebar = FloatSidebar({
        sidebar,
        relative,
        topSpacing: 140,
        bottomSpacing: 140
    });

    //product page scroll spy gallery
    let galleryItems = [];
    let galleryAvgPeek = 0;
    class GalleryItem {
        constructor(id, top) {
            this.id = id;
            this.top = top;
        }
    }

    $(".gallery-item").toArray().forEach(item => {
        let el = $(item);
        galleryItems.push(new GalleryItem(el.data("item"), el.position().top));
        galleryAvgPeek += el.height();
    });
    galleryAvgPeek = galleryAvgPeek / galleryItems.length / 2;

    let dontScrollSpy = false;
    $(".dots .dot").click(function () {
        dontScrollSpy = true;
        setTimeout(function () {
            dontScrollSpy = false;
        }, 1000);
        let el = $(this);
        if (el.hasClass("active")) return;

        let id = el.attr("id");

        $(window).scrollTop(galleryItems.find(x => x.id === id).top);
        $(".dots .dot.active").removeClass("active");
        el.addClass("active");
    });


    let productTxtWrp = $(".product-hero-wrapper .txt-wrp");
    let txtHeight = productTxtWrp.height() + Number(productTxtWrp.css("padding-top").replace("px", "")) + Number(productTxtWrp.css("padding-bottom").replace("px", ""));
    let galleryHeight = $(".product-gallery").height();
    let scrollHeight = galleryHeight - txtHeight - ($(window).height() - txtHeight);
    let bottle = $(".bottle-wrapper");
    let dots = $(".dots");
    let dotsMarginTop = dots.position().top;

    $(window).scroll(function () {
        if ($(window).scrollTop() >= scrollHeight) {
            bottle.removeClass("p-fixed");
            bottle.addClass("p-abs");
            bottle.css("top", scrollHeight);
            dots.removeClass("p-fixed");
            dots.addClass("p-abs");
            dots.css("top", scrollHeight + dotsMarginTop);
        } else {
            bottle.addClass("p-fixed");
            bottle.removeClass("p-abs");
            bottle.css("top", 0);
            dots.addClass("p-fixed");
            dots.removeClass("p-abs");
            dots.css("top", "45%");
        }
        if (dontScrollSpy) return;
        setActiveDot($(window).scrollTop() + galleryAvgPeek);
    });

    function setActiveDot(scrollPosition) {
        let currentDot = $(".dots .dot.active");
        if (scrollPosition >= galleryItems[galleryItems.length - 1].top && currentDot.attr("id") != galleryItems[galleryItems.length - 1].id) {
            currentDot.removeClass("active");
            $(`#${galleryItems[galleryItems.length - 1].id}`).addClass("active");
            return;
        }
        if (scrollPosition <= galleryItems[1].top && currentDot.attr("id") != galleryItems[0].id) {
            currentDot.removeClass("active");
            $(`#${galleryItems[0].id}`).addClass("active");
            return;
        }
        for (let i = 1; i < galleryItems.length - 1; i++) {
            if (scrollPosition >= galleryItems[i].top && scrollPosition <= galleryItems[i + 1].top && currentDot.attr("id") != galleryItems[i].id) {
                currentDot.removeClass("active");
                $(`#${galleryItems[i].id}`).addClass("active");
                return;
            }
        }
    }
});